export default "__VITE_ASSET__7a3875b4__"